import React from 'react'

const AntiClippy = () => (
   <img src = {require('./assets/antiClippy.png')} alt="ntiClippy" />
)
export default AntiClippy